import { useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";

interface Props {
  onLogout?: () => void;
}

const SessionTimeout: React.FC<Props> = ({ onLogout }) => {
  const { logout, isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    // Check if we have any tokens at all
    const hasAccessToken = !!localStorage.getItem('access_token');
    const hasRefreshToken = !!localStorage.getItem('refresh_token');
    
    if (!hasAccessToken && !hasRefreshToken) {
      if (onLogout) {
        onLogout();
      } else {
        logout();
      }
    }

  }, [isAuthenticated, onLogout, logout]);

  return null;
};

export default SessionTimeout;
